import dayjs from "dayjs";

import INotification from "@/interfaces/notification.interface";
import { NotificationsMessages } from "@/messages/notifications/notifications.messages";

interface Props {
  notification: INotification;
  messages: NotificationsMessages;
}

interface Return {
  formattedDateTime: string;
  details: string;
  readLabel: string;
}

function useNotificationData({ notification, messages }: Props): Return {
  const formattedDateTime = notification.rowDate
    ? dayjs(notification.rowDate).format("DD/MM/YYYY HH:mm")
    : "-";
  const details = notification.detail || "-";
  const readLabel = notification.read ? messages.yesOption : messages.noOption;

  return { formattedDateTime, details, readLabel };
}

export default useNotificationData;
